import { Collapse } from "antd";

import Resource from "./Resource";
import Subsection from "./Subsection";
import Task from "./Task";

const { Panel } = Collapse;

const CourseSection = ({ sectionDetails = {}, courseId, ROOT_URL, educatorList = [] }) => {
  return (
    <Collapse>
      <Panel header="Subsections" key={courseId + "subsections"}>
        <Subsection
          ROOT_URL={ROOT_URL}
          sectionSubsections={sectionDetails?.sectionDetails?.subsections || []}
          resources={sectionDetails?.resources || []}
          sectionId={sectionDetails?.sectionId}
          educatorList={educatorList}
        />
      </Panel>
      <Panel header="Resources" key={courseId + "resources"}>
        <Resource
          ROOT_URL={ROOT_URL}
          sectionResources={sectionDetails?.resources || []}
          courseId={courseId}
          sectionId={sectionDetails?.sectionId}
        />
      </Panel>
      <Panel header="Tasks" key={courseId + "tasks"}>
        <Task
          ROOT_URL={ROOT_URL}
          sectionName={sectionDetails?.sectionDetails?.name}
          sectionTasks={sectionDetails?.tasks || []}
          courseId={courseId}
          sectionId={sectionDetails?.sectionId}
        />
      </Panel>
    </Collapse>
  );
};

export default CourseSection;
